import * as React from 'react'
import { CommonPlaybackAction, PlaybackBlock } from './Headline/PlaybackBlock'
import { DVString } from '@utils'
import { Offers } from './Headline/Offers'
import * as styles from './Headline.module.scss'

interface HeadlineProps {
    title?: string
    playbackAction: CommonPlaybackAction
    offers?: DVString[]
}

export const Headline = (props: HeadlineProps) => {
    if (props.playbackAction)
        return (props.playbackAction &&
            <PlaybackBlock
                playbackAction={{
                    ...props.playbackAction,
                    label: props.playbackAction.label || props.title
                }} />)
    else if (props.offers && props.offers.length > 0)
        return <Offers offers={props.offers} />
    else if (props.title)
        return <span className={styles.title}>{props.title}</span>
    return null
}